export const privacyPolicyHtml = `
<h1>CrenelView Privacy Policy</h1>
<p class="stamp">Last updated: August 2026</p>

<p class="lede">CrenelView collects nothing. There is no account, no server, and the app does not
hold permission to use the internet at all.</p>

<div class="card">
  <p><strong>The short version.</strong> Every decision CrenelView makes happens on your phone.
  Your settings and your PIN stay on your phone. Nothing is uploaded, because the app has no
  technical means to upload anything.</p>
</div>

<h2>What we do not collect</h2>
<p>We do not collect, store off your device, transmit, sell, or share any of the following:</p>
<ul>
  <li>Your name, email address, phone number, or any other identifying detail.</li>
  <li>Your location.</li>
  <li>Your contacts, photos, messages, or files.</li>
  <li>Which apps you or your child use, or for how long. CrenelView does not request the usage
  access permission, so it cannot read app usage statistics even if it wanted to.</li>
  <li>Any advertising identifier. There are no ads and no advertising libraries.</li>
  <li>Crash reports or analytics. There is no analytics library of any kind.</li>
</ul>

<h2>What stays on your phone</h2>
<p>CrenelView saves two things locally, and neither ever leaves the device:</p>
<ul>
  <li><strong>Your settings.</strong> Which apps you chose to block, the daily time windows you
  set, and whether protection is on. These live in a private file only CrenelView can read.</li>
  <li><strong>Your parent PIN.</strong> Stored as a salted SHA-256 hash inside Android's
  EncryptedSharedPreferences. The PIN itself is never written down anywhere, and the stored hash
  cannot be turned back into your PIN.</li>
</ul>
<p>Uninstalling CrenelView removes both.</p>

<h2>The accessibility permission</h2>
<p>CrenelView needs one permission that you switch on yourself during setup: an Android
accessibility service. This is the mechanism that closes the apps you chose to block. Here is
exactly what it does and does not do.</p>
<ul>
  <li>It sees which app has just come to the foreground. If that app is one you blocked, it sends
  the phone back to the home screen.</li>
  <li>While protection is on, it reads the text on screen for one narrow purpose only: to tell
  whether the settings page in front of it is the one holding CrenelView's own switch, so a child
  cannot turn protection off. It looks only at settings screens, and only for our own name.</li>
  <li>It never blocks uninstalling. Removing CrenelView works normally at any time, from the
  launcher, the app info page, or Play.</li>
  <li>It does not read what you type. It does not read your messages, your browsing, your
  passwords, or the contents of any other app.</li>
  <li>Nothing it sees is stored. Nothing it sees is transmitted. The app has no internet
  permission, so transmission is not technically possible.</li>
</ul>

<h2>The installed app list</h2>
<p>So that you can choose which apps to block, and so that a game installed later can be blocked
automatically if you asked for that, CrenelView can see which apps are installed on the phone.
That list is used on the device only, to draw the settings screen. It is never sent anywhere.</p>

<h2>Children</h2>
<p>CrenelView is a tool for a parent, installed on the parent's own phone. It is not designed for
a child to use and it does not collect information about anyone, child or adult.</p>

<h2>Third parties</h2>
<p>There are none. CrenelView contains no advertising network, no analytics provider and no
crash reporter. It makes no network requests.</p>

<h2>Your control</h2>
<p>Because nothing is collected, there is no data to request, export, correct, or delete from us.
Everything CrenelView knows is on your phone, visible in the app, and removed when you uninstall
it.</p>

<h2>Changes to this policy</h2>
<p>If a future version of CrenelView ever needs to handle data differently, this policy will be
updated before that version ships, and the date at the top will change.</p>

<h2>Contact</h2>
<p>Questions about this policy: <a href="mailto:support@crenelview.com">support@crenelview.com</a>.</p>
`;
